import { render } from "./InfoBlock.vue?vue&type=template&id=0c33e5d4&scoped=true"
import script from "./InfoBlock.vue?vue&type=script&lang=js"
export * from "./InfoBlock.vue?vue&type=script&lang=js"

import "./InfoBlock.vue?vue&type=style&index=0&id=0c33e5d4&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c33e5d4"]])

export default __exports__